<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      v-can="'stocktakingtool.update'"
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        style="margin-left: 5px;"
        @click="updateStockTakingTool"
      />
    </el-tooltip>
    <el-tooltip
      v-can="'stocktakingtool.delete'"
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
    >
      <el-popover
        v-model="deleteConfirmVisible"
        placement="bottom"
        width="171"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteStockTakingTool"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['stockTakingTool'],
    data() {
      return {
        deleteButtonLoader: false,
        closeButtonLoader: false,
        deleteConfirmVisible: false,
      };
    },

    methods: {
      async deleteStockTakingTool() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('stockTakingTool/delete', this.stockTakingTool.id);
          this.$store.dispatch('stockTakingTool/fetchAll');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },
      updateStockTakingTool() {
        this.$router.push('/processes/stock-takings/stock-taking-tools/update/' + this.stockTakingTool.id);
      },
    }
  };
</script>

